module.exports = __webpack_public_path__ + "static/media/calculate.0e21ba52.png";